// Stash a deep-link path while the user is unauthenticated, then resume after sign-in.
// Used by AuthContext to honour push/email links that land on /auth.

const STORAGE_KEY = "pendingDeepLink";

// Routes that should NEVER be stashed (public, marketing, or auth-flow themselves).
const PUBLIC_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/landing(\/|$|\?)/,
  /^\/index(\/|$|\?)/,
  /^\/auth(\/|$|\?)/,
  /^\/login(\/|$|\?)/,
  /^\/signup(\/|$|\?)/,
  /^\/reset-password(\/|$|\?)/,
  /^\/verify(\/|$|\?)/,
  /^\/legal(\/|$|\?)/,
  /^\/privacy(\/|$|\?)/,
  /^\/terms(\/|$|\?)/,
  /^\/about(\/|$|\?)/,
  /^\/storefront(\/|$|\?)/,
  /^\/channel\/join(\/|$|\?)/, // already has its own join flow
];

function isStashable(pathWithSearch: string): boolean {
  if (!pathWithSearch) return false;
  return !PUBLIC_PATTERNS.some((re) => re.test(pathWithSearch));
}

export function stashPendingDeepLink(pathWithSearch: string): void {
  try {
    if (!isStashable(pathWithSearch)) return;
    sessionStorage.setItem(STORAGE_KEY, pathWithSearch);
  } catch { /* ignore */ }
}

export function consumePendingDeepLink(): string | null {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    if (v) sessionStorage.removeItem(STORAGE_KEY);
    return v;
  } catch {
    return null;
  }
}

/** Call once on app boot in unauthenticated state to capture the entry URL. */
export function captureEntryDeepLinkIfUnauthed(): void {
  try {
    const path = window.location.pathname + window.location.search;
    if (isStashable(path)) {
      // Don't overwrite an existing stash from an earlier visit.
      if (!sessionStorage.getItem(STORAGE_KEY)) {
        sessionStorage.setItem(STORAGE_KEY, path);
      }
    }
  } catch { /* ignore */ }
}
